import { api } from "@//api";
import { queryClient } from "@/queryClient";

export const departBooking = async (id: string) => {
  const resp = await api.put(`/bookings/${id}/manual-depart`);
  queryClient.invalidateQueries(["bookings"]);
  queryClient.invalidateQueries(["messages"]);
  return resp;
};
